export const missingDataPlaceholder = <h2>-</h2>;
export const emptyString = '';
